import { AuthService } from '.';

const Interseptor = {

  requestHandler(request) {
    return request;
  },

  errorHandler(error) {
    if (error && error.response.status === 401 && sessionStorage.authToken) {
      AuthService.signOut();
      window.location.href = '/login';
      return {};
    }
    return Promise.reject({ ...error });
  },

  successHandler(response) {
    return response;
  },

};

export default Interseptor;
